var _excluded = ["children", "size", "isSticky", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from 'react';
import { useTestId } from '../../../../../utils';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { Text } from '../../../../dataDisplay/Text';
import { Box } from '../../../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
export var HeaderCell = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    children,
    size,
    isSticky,
    'data-testid': dataTestId = 'form-line-items-header-cell'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('FormLineItems', {
    size
  });
  var getTestId = useTestId(dataTestId);
  var content = typeof children === 'string' ? /*#__PURE__*/_jsx(Text, {
    color: "neutral.darker",
    textStyle: "body4Semi",
    shouldSupportEllipsis: true,
    children: children
  }) : children; // For a11y - table header can't be empty
  // The closest reference is table with two headers
  // https://www.w3.org/WAI/tutorials/tables/two-headers/

  var role = content ? 'columnheader' : 'cell'; // We need a cell content layer cause flex doesn't play well with padding

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({
    __css: styles['headerCell'],
    ref: ref,
    "data-is-sticky": isSticky,
    "data-component": "FormLineItems.HeaderCell",
    role: role
  }, getTestId()), props), {}, {
    children: /*#__PURE__*/_jsx(Box, {
      __css: styles['headerCellContent'],
      children: content
    })
  }));
});
HeaderCell.displayName = 'FormLineItems.HeaderCell';
//# sourceMappingURL=HeaderCell.js.map